module.exports = __webpack_public_path__ + "static/variety-image-2-219c0893ebbacffc01b9a70ac5179ad4.jpg";